module.exports = __webpack_public_path__ + "img/drop-right-hover.b7413302.svg";